module.exports = __webpack_public_path__ + "media/icons/columns-gray-e7276585.png";